import { supabase } from './supabaseClient';

/**
 * Fetches the global percentage from the settings table.
 * Assumes there’s only one row with id = 1.
 * @returns {Promise<number>} The current percentage value
 * @throws {Error} If the request fails
 */
export async function getGeneralPercentage() {
  try {
    const { data, error } = await supabase
      .from('settings')
      .select('percentage')
      .eq('id', 1)
      .single();

    if (error) {
      if (error.code === 'PGRST116') { // No rows found
        return 0; // Default value if no settings exist
      }
      throw new Error(`Failed to fetch percentage: ${error.message}`);
    }
    return data.percentage || 0;
  } catch (error) {
    console.error('getGeneralPercentage error:', error.message);
    throw error;
  }
}

/**
 * Saves the global percentage in the settings table.
 * Ensures only one row exists with id = 1, updating it if present or inserting it explicitly.
 * @param {number} percentage - The new percentage value to save
 * @returns {Promise<void>}
 * @throws {Error} If the request fails
 */
export async function saveGeneralPercentage(percentage) {
  try {
    if (typeof percentage !== 'number' || percentage < 0) {
      throw new Error('Invalid percentage value');
    }

    // Use upsert to ensure a single row with id = 1
    const { error } = await supabase
      .from('settings')
      .upsert(
        {
          id: 1, // Explicitly set id to 1
          percentage,
          created_at: new Date().toISOString(),
          updated_at: new Date().toISOString(),
        },
        {
          onConflict: 'id', // Update if id = 1 already exists
        }
      );

    if (error) throw new Error(`Failed to save percentage: ${error.message}`);
  } catch (error) {
    console.error('saveGeneralPercentage error:', error.message);
    throw error;
  }
}